import React from 'react';
import './GetInvolved.css';

const GetInvolved = () => {
  return (
    <div className="get-involved">
      <div className="container">
        <section className="section">
          <h2>Get Involved</h2>
          <div className="card">
            <p>Interested in volunteering, partnering, or sponsoring with us? We welcome volunteers and community support to expand our impact.</p>
            <p>Contact us at <b>swimwithasplash@gmail.com</b> for more information or if you have any questions.</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default GetInvolved;
